package gr.tech.pdfgenerator.styles

import com.varabyte.kobweb.compose.css.BorderCollapse
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

/*   General Styles */
val topDivider = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .borderTop(1.px, LineStyle.Solid, Colors.Black)
            .padding(top = 30.px)
            .margin(top = 30.px)
    }
}

val bottomDivider = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .borderBottom(1.px, LineStyle.Solid, Colors.Black)
            .padding(bottom = 5.px)
            .margin(bottom = 30.px)
    }
}

val headerTitleStyle = CssStyle {
    base {
        Modifier
            .fontFamily(FONT_FAMILY)
            .fontSize(2.cssRem)
            .margin(
                topBottom = 12.px
            )
            .width(500.px)
    }
}


/*   LINKED VALUES STYLES   */
val linkedValuesHalfStyle = CssStyle {
    base {
        Modifier
            .width(550.px)
    }
}

val HeadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(3.cssRem)
        .textAlign(TextAlign.Start)
        .lineHeight(1.2) //1.5x doesn't look as good on very large text
}

val SubheadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .textAlign(TextAlign.Start)
        .color(colorMode.toPalette().color.toRgb().copyf(alpha = 0.8f))
}

val CircleButtonVariant = com.varabyte.kobweb.silk.components.forms.ButtonStyle.addVariantBase {
    Modifier.padding(0.px).borderRadius(50.percent)
}

val UncoloredButtonVariant = com.varabyte.kobweb.silk.components.forms.ButtonStyle.addVariantBase {
    Modifier.setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
}

/*    TABLE STYLES    */
val blueBackStyle = CssStyle.base {
    Modifier
        .backgroundColor(Colors.LightSkyBlue)
}

val lightBlueBackStyle = CssStyle.base {
    Modifier
        .backgroundColor(Colors.LightBlue)
}

val DarkGreenBackStyle = CssStyle.base {
    Modifier
        .backgroundColor(Colors.DarkOliveGreen)
        .color(Colors.White)
        .border(2.px, LineStyle.Solid, Colors.Black)
}

val labelCellStyle = CssStyle.base {
    Modifier
        .fontWeight(FontWeight.Bold)
        .fontSize(1.cssRem)
        .width(220.px)
        .textAlign(TextAlign.End)
}

val cellStyle = CssStyle.base {
    Modifier
        .textAlign(TextAlign.Center)
        .width(100.px)
        .borderCollapse(BorderCollapse.Separate)
}